import { ProductModal } from '../../product/modal/product-modal';
import { InwardStockModal } from './inward-stock-modal';

export class InwardStockByName {
  public product: ProductModal;
  public item: ProductModal;
  public dataList: Array<InwardStockModal>;
  public isSelected: boolean = false;
  public total: number;
  public totalBlockStock: number;
  public totalSecondaryStock: number;
  public typeList: string;
  public customItemNumber: string;
  public productTypes: string;
}
